import { Component } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import "./LanguageDropdown.css";
import axios from "axios";
import Util from "../../util/util";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";

class HeaderComponent extends Component {
  constructor() {
    super();
    var params = new URLSearchParams(window ? window.location.search : {});
    this.state = {
      currentLocation: params.get("l") ? params.get("l") : 0,
      currentSearch: params.get("q") ? params.get("q") : "",
      loginEmail: "",
      loginPass: "",
      usernameError: "",
      passwordError: "",
      showLogin: false,
      loadingLogin: false,
      usersData: localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : {},
      unread_messages: 0,
      facebookLogin: "",
      updateEvent: false,
      showLanguageDropdown: false,
    };
  }

  path = (path) => {
    return this.props.getPathWithLanguage ? this.props.getPathWithLanguage(path, this.props.currentLanguage) : path;
  };

  searchProducts = () => {
    if (!this.state.currentSearch || this.state.currentSearch.length < 3) {
      return false;
    }

    this.props.navigate(
      this.path("/pretraga") + "?q=" + this.state.currentSearch + (this.state.currentLocation ? "&l=" + this.state.currentLocation : "")
    );
  };

  showHideLogin = (alwaysHide) => {
    var doHide = !this.state.showLogin;
    if (alwaysHide == true) {
      doHide = false;
    }

    if (doHide) {
      window.addBlur(".Page");
    } else {
      window.removeBlur(".Page");
    }

    this.setState({ showLogin: doHide }, function () {
      if (this.state.showLogin) {
        Util.hideOnOutsideClick(
          [
            "header_app",
            "header_login_div",
            "header_login",
            "header_postbutton",
            "app_btn_menu",
            "app_btn_msg",
            "app_btn_profile",
            "add_btn",
          ],
          () => {
            this.showHideLogin(true);
          }
        );
      }
    });
  };

  doCloseLogin = () => {
    window.removeBlur(".Page");
    this.setState({
      showLogin: false,
      showUserMenu: false,
    });
  };

  showHideMenu = (alwaysHide) => {
    var doHide = !this.state.showUserMenu;
    if (alwaysHide == true) {
      doHide = false;
    }

    this.setState({ showUserMenu: doHide }, function () {
      if (this.state.showUserMenu) {
        Util.hideOnOutsideClick(["header_loggeduser", "app_btn_menu"], () => {
          this.showHideMenu(true);
        });
      }
    });
  };

  showHideLanguageDropdown = (alwaysHide) => {
    var doHide = !this.state.showLanguageDropdown;
    if (alwaysHide === true) {
      doHide = false;
    }

    this.setState({ showLanguageDropdown: doHide }, function () {
      if (this.state.showLanguageDropdown) {
        Util.hideOnOutsideClick(["language_dropdown", "language_button"], () => {
          this.showHideLanguageDropdown(true);
        });
      }
    });
  };

  doLogin = (doFacebook) => {
    var mainThis = this;
    this.setState({ usernameError: "", passwordError: "" });
    if (!Util.checkParams(this.state.loginEmail, "emailphonename") && !doFacebook) {
      //Wrong username / email / phone
      this.setState({ usernameError: this.props.t ? this.props.t('login.errors.usernameInvalid') : "Korisničko ime, email ili broj telefona nisu pravilno upisani" });
    } else if (!Util.checkParams(this.state.loginPass, "password") && !doFacebook) {
      // Wrong password
      this.setState({ passwordError: this.props.t ? this.props.t('login.errors.passwordInvalid') : "Password / Lozinka nije pravilno upisan" });
    } else {
      this.setState({ loadingLogin: true });
      /*  firebase.initializeApp();
      const fcmtoken = getMessaging()
        .getToken()
        .then((mainToken) => {
          return mainToken;
        });

      fcmtoken.then((token) => console.log("fcmtoken:::", token)); */
      axios
        .post(window.ajaxLink + "user/login", {
          username: this.state.loginEmail,
          password: this.state.loginPass,
          facebookLogin: this.state.facebookLogin,
        })
        .then((res) => {
          if (res["data"] && res["data"]["responseData"] && res["data"]["responseData"]["id"]) {
            Util.eList = [];
            Util.callback = false;

            localStorage.clear();

            mainThis.setState({ showLogin: false, loadingLogin: false, usersData: res["data"]["responseData"] });
            window.removeBlur(".Page");
            localStorage.setItem("user_data", JSON.stringify(res["data"]["responseData"]));

            mainThis.getUnreadCount();
            window.location.reload();
          } else {
            mainThis.setState({ loadingLogin: false, passwordError: "Korisnički detalji nisu ispravni." });
          }
        })
        .catch((err) => {
          Util.handleAjaxError(err, mainThis);
          mainThis.setState({ loadingLogin: false });
        });
    }
  };

  doLogOut = () => {
    Util.saveCustomEvent("do_logout");

    this.setState({ showLogin: false, showUserMenu: false, usersData: {} });
    window.removeBlur(".Page");
    localStorage.clear();
    if (window.FB && window.FB.getUserID()) {
      window.FB.logout();
    }
    window.location.href = "/";
  };

  componentDidMount() {
    this.getUnreadCount();
    window.addEventListener("unread", () => {
      // console.log("Time for reload!");
      this.getUnreadCount();
    });
  }

  getUnreadCount() {
    if (this.state.usersData && this.state.usersData.id && this.state.usersData.token) {
      if (window.gtag && this.state.usersData) {
        window.gtag("set", "user_properties", { username: this.state.usersData.name });
      }

      var mainThis = this;
      axios.defaults.headers.common["Authorization"] = this.state.usersData.token;
      axios
        .get(window.ajaxLink + "message/count")
        .then((res) => {
          if (res["data"] && res["data"]["responseData"] && res["data"]["responseData"]["messagesCount"]) {
            mainThis.setState({ unread_messages: res["data"]["responseData"]["messagesCount"] });
          } else {
            mainThis.setState({ unread_messages: 0 });
          }

          if (res["data"] && res["data"]["responseData"] && res["data"]["responseData"]["remindNoPay"] == 1) {
            var lastShowPay = localStorage.getItem("last_paid_date");
            if (!lastShowPay) {
              lastShowPay = -1;
            }

            if (lastShowPay < new Date().getTime() - 60 * 60 * 24 * 1000) {
              Util.saveCustomEvent("show_expired");

              Util.showPopupDialog(
                "Besplatan probni period je istekao!",
                "Nažalost, besplatan probni period Vam je istekao i nismo u mogućnosti da potvrdimo Vašu uplatu za dalju prodaju. Uskoro ćemo biti prinuđeni da uklonimo Vaše oglase i ponudimo oglase drugih radnji.",
                {
                  title: "Plaćanje",
                  css: "middle_popup_yellow_button",
                  callback: () => {
                    localStorage.setItem("last_paid_date", new Date().getTime());
                    window.location.href = this.path("/placanje#pobtn");
                  },
                },
                {
                  title: "Zatvori",
                  css: "middle_popup_blue_button",
                  callback: () => {
                    Util.saveCustomEvent("show_expired_close");
                    localStorage.setItem("last_paid_date", new Date().getTime());
                  },
                },
                () => {},
                "warning_popup"
              );
            }
          }

          mainThis.createListeningUpdate();
        })
        .catch((err) => {
          mainThis.setState({ unread_messages: 0 });
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.errorData &&
            err.response.data.errorData.name == "TokenExpiredError"
          ) {
            mainThis.setState({ showLogin: false, showUserMenu: false, usersData: {} });
            window.removeBlur(".Page");
            localStorage.removeItem("user_data");
            window.location.reload();
          }
        });
    }
  }

  createListeningUpdate() {
    if (this.state.updateEvent) {
      this.state.updateEvent.close();
    }

    if (this.state.usersData && this.state.usersData.id && this.state.usersData.token) {
      var mainThis = this;
      var newEvent = Util.listenSSEvent(
        "user_listening",
        window.ajaxLink +
          "sse/subscribe?name=userId&value=" +
          this.state.usersData.id +
          "&token=" +
          this.state.usersData.token
      );

      Util.addSSEventCallback("user_listening", "header_listen", function (data) {
        if (data && data["update"] && data["update"]["messageCount"] !== undefined) {
          if (mainThis.state.unread_messages !== data["update"]["messageCount"]) {
            mainThis.setState({ unread_messages: data["update"]["messageCount"] });
          }
        }
      });

      this.setState({ updateEvent: newEvent });
    }
  }

  loginFacebook = () => {
    if (window.FB) {
      var mainThis = this;
      window.FB.login(
        function (response) {
          if (response && response.authResponse && response.authResponse.accessToken) {
            mainThis.setState({ facebookLogin: response.authResponse.accessToken }, () => {
              mainThis.doLogin(true);
            });
          }
        },
        { scope: "public_profile,email" }
      );
    }
  };

  render() {
    return (
      <div className="header">
        <div className="header_middle">
          <Link to={this.path("/")} aria-label="OPK.ba početna">
            <div className="header_logo"></div>
          </Link>
          <div className="header_search header_search_desktop">
            <div className="header_location">
              <select
                id="search_location"
                onChange={(event) => {
                  this.setState({ currentLocation: event.target.value });
                }}
                value={this.state.currentLocation}
              >
                <option value="0">Sve Lokacije</option>
                <option value="" disabled="disabled" style={{ color: "inherit", background: "#ccc" }}>
                  Republika Srpska
                </option>
                <option value="1">Banjalučka</option>
                <option value="2">Dobojsko-Bijeljinska</option>
                <option value="3">Sarajevsko-Zvornička</option>
                <option value="4">Trebinjsko-Fočanska</option>
                <option value="" disabled="disabled" style={{ color: "inherit", background: "#ccc" }}>
                  Federacija BiH
                </option>
                <option value="5">Sarajevo</option>
                <option value="6">Unsko-sanski</option>
                <option value="7">Posavski</option>
                <option value="8">Tuzlanski</option>
                <option value="9">Zeničko-dobojski</option>
                <option value="10">Bosansko-podrinjski</option>
                <option value="11">Srednjobosanski</option>
                <option value="12">Hercegovačko-neretvanski</option>
                <option value="13">Zapadno-hercegovački</option>
                <option value="14">Livanjski</option>
                <option value="15">Distrikt Brčko</option>
              </select>
            </div>
            <div className="header_search_input">
              <input
                type="text"
                name="search_top"
                id="search_top"
                value={this.state.currentSearch}
                onChange={(event) => this.setState({ currentSearch: event.target.value })}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    this.searchProducts();
                  }
                }}
                placeholder={this.props.t ? this.props.t('header.search.placeholder') : "Probajte: Laptop HP"}
              />
              <div onClick={this.searchProducts}></div>
            </div>
          </div>
          {/* Language Dropdown */}
          <div className="language_selector">
            <div 
              id="language_button"
              className="language_button" 
              onClick={this.showHideLanguageDropdown}
            >
              <span className={`flag flag-${this.props.currentLanguage}`}></span>
              {this.props.currentLanguage?.toUpperCase()}
              <span className="dropdown_arrow">▼</span>
            </div>
            <div 
              id="language_dropdown"
              className={"language_dropdown" + (this.state.showLanguageDropdown ? " active" : "")}
            >
              <div 
                className={"language_option" + (this.props.currentLanguage === 'ba' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('ba');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-ba"></span>
                Ba
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'en' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('en');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-en"></span>
                En
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'fr' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('fr');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-fr"></span>
                Fr
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'es' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('es');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-es"></span>
                Es
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'it' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('it');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-it"></span>
                It
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'ru' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('ru');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-ru"></span>
                Ru
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'ar' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('ar');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-ar"></span>
                Ar
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'de' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('de');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-de"></span>
                De
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'pt' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('pt');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-pt"></span>
                Pt
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'tr' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('tr');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-tr"></span>
                Tr
              </div>
              <div 
                className={"language_option" + (this.props.currentLanguage === 'zh' ? ' active' : '')}
                onClick={() => {
                  this.props.changeLanguage('zh');
                  this.showHideLanguageDropdown(true);
                }}
              >
                <span className="flag flag-zh"></span>
                Zh
              </div>
            </div>
          </div>

          {this.state.usersData.id == undefined && (
            <div id="header_login" className="header_login" onClick={this.showHideLogin}>
              {this.props.t ? this.props.t('header.login') : "Prijava"}
            </div>
          )}
          <div className="header_login_pix">
            <div id="header_login_div" className={"header_login_div" + (this.state.showLogin ? " active" : "")}>
              <div className="header_login_left">
                <div className="header_login_chat">
                  <div>{this.props.t ? this.props.t('login.features.chatTitle') : 'Razmjena poruka sa kupcima i prodavcima'}</div>
                  {this.props.t ? this.props.t('login.features.chatDescription') : 'Šaljite i primajte poruke, komentarišite proizvode, šaljite ponude, itd.'}
                </div>
                <div className="header_login_delivery">
                  <div>{this.props.t ? this.props.t('login.features.deliveryTitle') : 'Sigurna i brza dostava'}</div>
                  {this.props.t ? this.props.t('login.features.deliveryDescription') : 'Besplatna dostava za neke od ponuđenih proizvoda.'}
                </div>
                <div className="header_login_shop">
                  <div>{this.props.t ? this.props.t('login.features.shopTitle') : 'Besplatno otvaranje online radnje'}</div>
                  {this.props.t ? this.props.t('login.features.shopDescription') : 'Postavljanje proizvoda za prodaju je besplatno za sve radnje.'}
                </div>
              </div>
              <div className="header_login_right">
                <div
                  className="mobile_close"
                  onClick={() => {
                    this.setState({ showLogin: false });
                    window.removeBlur(".Page");
                  }}
                >
                  &times;
                </div>
                <form onSubmit={this.doLogin}>
                  <div className="header_login_title">{this.props.t ? this.props.t('login.form.usernameEmailPhone') : 'Korisničko ime, email ili broj telefona'}</div>
                  <input
                    type="text"
                    name="header_login_email"
                    id="header_login_email"
                    value={this.state.loginEmail}
                    onChange={(event) => this.setState({ loginEmail: event.target.value })}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.doLogin();
                      }
                    }}
                    placeholder="064123..."
                  />
                  {this.state.usernameError && <div className="header_login_error">{this.state.usernameError}</div>}
                  <div className="header_login_title">{this.props.t ? this.props.t('login.form.password') : 'Password / Lozinka'}</div>
                  <input
                    type="password"
                    name="header_login_pass"
                    id="header_login_pass"
                    value={this.state.loginPass}
                    onChange={(event) => this.setState({ loginPass: event.target.value })}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.doLogin();
                      }
                    }}
                  />
                  {this.state.passwordError && <div className="header_login_error">{this.state.passwordError}</div>}
                  {/* <Link to="/zaboravljen-login"><div className="header_login_forgot">Zaboravili ste password?</div></Link> */}
                  <div className="header_login_button" onClick={this.doLogin}>
                    {this.props.t ? this.props.t('login.form.loginButton') : 'Prijava'}
                  </div>
                  <Link to={this.path("/lozinka")}>
                    <div className="forgotenPassword" onClick={this.doCloseLogin}>
                      {this.props.t ? this.props.t('login.form.forgotPassword') : 'Zaboravili ste lozinku?'}
                    </div>
                  </Link>
                </form>
                <div className="header_login_no_account">
                  <div className="header_login_no_account_text">{this.props.t ? this.props.t('login.form.noAccountText') : 'Ako se niste registrovali do sad:'}</div>
                  <Link
                    to={this.path("/registracija")}
                    onClick={() => {
                      this.setState({ showLogin: false });
                      window.removeBlur(".Page");
                    }}
                    className="header_register_button"
                  >
                    {this.props.t ? this.props.t('login.form.openNewAccount') : 'Otvorite Novi Nalog'}
                  </Link>
                  <div className="header_login_button_facebook" id="headerfacebooklogin" onClick={this.loginFacebook}>
                    {this.props.t ? this.props.t('login.form.facebookLogin') : 'Facebook Pristup'}
                  </div>
                </div>
                <div className={"loader_small" + (this.state.loadingLogin ? " active" : "")}></div>
              </div>
              <div className="header_login_mobile">
                <div className="header_login_chat">
                  <div>{this.props.t ? this.props.t('login.features.chatTitle') : 'Razmjena poruka sa kupcima i prodavcima'}</div>
                  {this.props.t ? this.props.t('login.features.chatDescription') : 'Šaljite i primajte poruke, komentarišite proizvode, šaljite ponude, itd.'}
                </div>
                <div className="header_login_delivery">
                  <div>{this.props.t ? this.props.t('login.features.deliveryTitle') : 'Sigurna i brza dostava'}</div>
                  {this.props.t ? this.props.t('login.features.deliveryDescription') : 'Besplatna dostava za neke od ponuđenih proizvoda.'}
                </div>
                <div className="header_login_shop">
                  <div>{this.props.t ? this.props.t('login.features.shopTitle') : 'Besplatno otvaranje online radnje'}</div>
                  {this.props.t ? this.props.t('login.features.shopDescription') : 'Postavljanje proizvoda za prodaju je besplatno za sve radnje.'}
                </div>
              </div>
            </div>
          </div>
          {this.state.usersData.id == undefined && (
            <Link to={this.path("/placanje")}>
              <div className="header_postbutton" id="header_postbutton">
                {this.props.t ? this.props.t('header.freeAd') : "Besplatan Oglas"}
              </div>
            </Link>
          )}

          {this.state.usersData.id !== undefined && (
            <div className="header_loggedin_section">
              <div
                id="header_loggeduser"
                className="header_loggeduser"
                onClick={this.showHideMenu}
                onTouchEnd={this.showHideMenu}
              >
                <div
                  className="header_userimage"
                  style={{
                    backgroundImage: this.state.usersData.image ? "url(" + this.state.usersData.image + ")" : "",
                  }}
                ></div>
                <div className="username_dropmenu">{this.state.usersData.name}&nbsp;</div>
                <div></div>
              </div>
              <Link to={this.path("/poruke")}>
                <div className="header_messages" key={"msg_count_" + this.state.unread_messages}>
                  {this.state.unread_messages > 0 ? <div>{this.state.unread_messages}</div> : ""}&nbsp;
                </div>
              </Link>
              <div
                id="header_dropdownmenu_div"
                className={"header_logged_dropdown" + (this.state.showUserMenu ? " active" : "")}
              >
                <Link to={this.path("/novaprodaja")}>
                  <div className="header_postbutton">Nova prodaja</div>
                </Link>

                <Link to={this.path("/radnja/" + this.state.usersData.name.toLowerCase())}>
                  <div className="header_group_spacing">Moj Profil</div>
                </Link>
                <Link to={this.path("/podesavanja")}>
                  <div>Podešavanja</div>
                </Link>
                <Link to={this.path("/obavjestenja")}>
                  <div>Obavještenja</div>
                </Link>
                <Link to={this.path("/statistika")}>
                  <div>Statistika</div>
                </Link>
                <Link to={this.path("/organizovanjeproizvoda")}>
                  <div>Organizovanje proizvoda</div>
                </Link>
                <Link to={this.path("/radnja/" + this.state.usersData.name.toLowerCase() + "#prosli")}>
                  <div>Prodati proizvodi</div>
                </Link>
                <Link to={this.path("/kupljeniproizvodi")}>
                  <div>Kupljeni proizvodi</div>
                </Link>
                <Link to={this.path("/istorijauplata")}>
                  <div>Plaćanje</div>
                </Link>

                <div className="header_group_spacing" onClick={this.doLogOut}>
                  Odjava
                </div>
              </div>
            </div>
          )}

          <div className="header_search header_search_mobile">
            <div className="header_location">
              <select
                id="search_location"
                onChange={(event) => {
                  this.setState({ currentLocation: event.target.value }, () => {
                    this.searchProducts();
                  });
                }}
                value={this.state.currentLocation}
              >
                <option value="0">Sve Lokacije</option>
                <option value="" disabled="disabled" style={{ color: "inherit", background: "#ccc" }}>
                  Republika Srpska
                </option>
                <option value="1">Banjalučka</option>
                <option value="2">Dobojsko-Bijeljinska</option>
                <option value="3">Sarajevsko-Zvornička</option>
                <option value="4">Trebinjsko-Fočanska</option>
                <option value="" disabled="disabled" style={{ color: "inherit", background: "#ccc" }}>
                  Federacija BiH
                </option>
                <option value="5">Sarajevo</option>
                <option value="6">Unsko-sanski</option>
                <option value="7">Posavski</option>
                <option value="8">Tuzlanski</option>
                <option value="9">Zeničko-dobojski</option>
                <option value="10">Bosansko-podrinjski</option>
                <option value="11">Srednjobosanski</option>
                <option value="12">Hercegovačko-neretvanski</option>
                <option value="13">Zapadno-hercegovački</option>
                <option value="14">Livanjski</option>
                <option value="15">Distrikt Brčko</option>
              </select>
            </div>
            <div className="header_search_input">
              <input
                type="text"
                name="search_top"
                id="search_top"
                value={this.state.currentSearch}
                onChange={(event) => this.setState({ currentSearch: event.target.value })}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    this.searchProducts();
                  }
                }}
                placeholder={this.props.t ? this.props.t('header.search.placeholder') : "Probajte: Laptop HP"}
              />
              <div onClick={this.searchProducts}></div>
            </div>
          </div>
        </div>

        <div id="header_app" className="header_app">
          <Link to={this.path("/")} aria-label="OPK.ba početna">
            <div className="header_logo"></div>
          </Link>
          <div className="header_search_input">
            <input
              type="text"
              name="search_top"
              id="search_top"
              value={this.state.currentSearch}
              onChange={(event) => this.setState({ currentSearch: event.target.value })}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  e.preventDefault();
                  this.searchProducts();
                }
              }}
              placeholder={this.props.t ? this.props.t('header.search.placeholder') : "Probajte: Laptop HP"}
            />
            <div onClick={this.searchProducts}></div>
          </div>

          {this.state.usersData.id == undefined && (
            <div id="header_login_div" className={"header_login_div" + (this.state.showLogin ? " active" : "")}>
              <div className="header_login_left">
                <div className="header_login_chat">
                  <div>{this.props.t ? this.props.t('login.features.chatTitle') : 'Razmjena poruka sa kupcima i prodavcima'}</div>
                  {this.props.t ? this.props.t('login.features.chatDescription') : 'Šaljite i primajte poruke, komentarišite proizvode, šaljite ponude, itd.'}
                </div>
                <div className="header_login_delivery">
                  <div>{this.props.t ? this.props.t('login.features.deliveryTitle') : 'Sigurna i brza dostava'}</div>
                  {this.props.t ? this.props.t('login.features.deliveryDescription') : 'Besplatna dostava za neke od ponuđenih proizvoda.'}
                </div>
                <div className="header_login_shop">
                  <div>{this.props.t ? this.props.t('login.features.shopTitle') : 'Besplatno otvaranje online radnje'}</div>
                  {this.props.t ? this.props.t('login.features.shopDescription') : 'Postavljanje proizvoda za prodaju je besplatno za sve radnje.'}
                </div>
              </div>
              <div className="header_login_right">
                <div
                  className="mobile_close"
                  onClick={() => {
                    this.setState({ showLogin: false });
                    window.removeBlur(".Page");
                  }}
                >
                  &times;
                </div>
                <form onSubmit={this.doLogin}>
                  <div className="header_login_title">{this.props.t ? this.props.t('login.form.usernameEmailPhone') : 'Korisničko ime, email ili broj telefona'}</div>
                  <input
                    type="text"
                    name="header_login_email"
                    id="header_login_email"
                    value={this.state.loginEmail}
                    onChange={(event) => this.setState({ loginEmail: event.target.value })}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.doLogin();
                      }
                    }}
                    placeholder="064123..."
                  />
                  {this.state.usernameError && <div className="header_login_error">{this.state.usernameError}</div>}
                  <div className="header_login_title">{this.props.t ? this.props.t('login.form.password') : 'Password / Lozinka'}</div>
                  <input
                    type="password"
                    name="header_login_pass"
                    id="header_login_pass"
                    value={this.state.loginPass}
                    onChange={(event) => this.setState({ loginPass: event.target.value })}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        this.doLogin();
                      }
                    }}
                  />
                  {this.state.passwordError && <div className="header_login_error">{this.state.passwordError}</div>}
                  {/* <Link to="/zaboravljen-login"><div className="header_login_forgot">Zaboravili ste password?</div></Link> */}
                  <div className="header_login_button" onClick={this.doLogin}>
                    {this.props.t ? this.props.t('login.form.loginButton') : 'Prijava'}
                  </div>
                  <Link to={this.path("/lozinka")}>
                    <div className="forgotenPassword" onClick={this.doCloseLogin}>
                      {this.props.t ? this.props.t('login.form.forgotPassword') : 'Zaboravili ste lozinku?'}
                    </div>
                  </Link>
                </form>
                <div className="header_login_no_account">
                  <div className="header_login_no_account_text">{this.props.t ? this.props.t('login.form.noAccountText') : 'Ako se niste registrovali do sad:'}</div>
                  <Link
                    to={this.path("/registracija")}
                    onClick={() => {
                      this.setState({ showLogin: false });
                      window.removeBlur(".Page");
                    }}
                    className="header_register_button"
                  >
                    {this.props.t ? this.props.t('login.form.openNewAccount') : 'Otvorite Novi Nalog'}
                  </Link>
                  <div className="header_login_button_facebook" id="headerfacebooklogin" onClick={this.loginFacebook}>
                    {this.props.t ? this.props.t('login.form.facebookLogin') : 'Facebook Pristup'}
                  </div>
                </div>
                <div className={"loader_small" + (this.state.loadingLogin ? " active" : "")}></div>
              </div>
              <div className="header_login_mobile">
                <div className="header_login_chat">
                  <div>{this.props.t ? this.props.t('login.features.chatTitle') : 'Razmjena poruka sa kupcima i prodavcima'}</div>
                  {this.props.t ? this.props.t('login.features.chatDescription') : 'Šaljite i primajte poruke, komentarišite proizvode, šaljite ponude, itd.'}
                </div>
                <div className="header_login_delivery">
                  <div>{this.props.t ? this.props.t('login.features.deliveryTitle') : 'Sigurna i brza dostava'}</div>
                  {this.props.t ? this.props.t('login.features.deliveryDescription') : 'Besplatna dostava za neke od ponuđenih proizvoda.'}
                </div>
                <div className="header_login_shop">
                  <div>{this.props.t ? this.props.t('login.features.shopTitle') : 'Besplatno otvaranje online radnje'}</div>
                  {this.props.t ? this.props.t('login.features.shopDescription') : 'Postavljanje proizvoda za prodaju je besplatno za sve radnje.'}
                </div>
              </div>
            </div>
          )}
        </div>

        {this.state.usersData.id && (
          <div className="footer_app">
          <Link to={this.path("/")} aria-label="OPK.ba početna">
            <div className="footer_app_btn app_btn_home"></div>
          </Link>
          {this.state.usersData.id && (
            <Link to={this.path("/poruke")}>
              <div className="footer_app_btn app_btn_msg" key={"msg_count_" + this.state.unread_messages}>
                {this.state.unread_messages > 0 ? <div>{this.state.unread_messages}</div> : ""}&nbsp;
              </div>
            </Link>
          )}
          {!this.state.usersData.id && (
            <div id="app_btn_msg" className="footer_app_btn app_btn_msg" onClick={this.showHideLogin}></div>
          )}
          {this.state.usersData.id && (
            <Link to={this.path("/novaprodaja")}>
              <div className="add_btn">&#43;</div>
            </Link>
          )}
          {!this.state.usersData.id && (
            <div id="add_btn" className="add_btn" onClick={this.showHideLogin}>
              &#43;
            </div>
          )}
          {this.state.usersData.id && (
            <Link to={this.path("/radnja/" + this.state.usersData.name.toLowerCase())}>
              <div
                className="footer_app_btn app_btn_profile"
                style={{ backgroundImage: this.state.usersData.image ? "url(" + this.state.usersData.image + ")" : "" }}
              ></div>
            </Link>
          )}
          {!this.state.usersData.id && (
            <div id="app_btn_profile" className="footer_app_btn app_btn_profile" onClick={this.showHideLogin}></div>
          )}
          {this.state.usersData.id && (
            <div id="app_btn_menu" className="footer_app_btn app_btn_menu" onClick={this.showHideMenu}>
              <div className="hamburger_line"></div>
              <div className="hamburger_line"></div>
              <div className="hamburger_line"></div>
            </div>
          )}
          {!this.state.usersData.id && (
            <div id="app_btn_menu" className="footer_app_btn app_btn_menu" onClick={this.showHideLogin}>
              <div className="hamburger_line"></div>
              <div className="hamburger_line"></div>
              <div className="hamburger_line"></div>
            </div>
          )}
          </div>
        )}
        {this.state.usersData.id !== undefined && (
          <div
            id="header_dropdownmenu_div2"
            className={"header_logged_dropdown2" + (this.state.showUserMenu ? " active" : "")}
          >
            <Link to={this.path("/novaprodaja")}>
              <div className="header_postbutton">Nova prodaja</div>
            </Link>

            <Link to={this.path("/radnja/" + this.state.usersData.name.toLowerCase())}>
              <div className="header_group_spacing">Moj Profil</div>
            </Link>
            <Link to={this.path("/podesavanja")}>
              <div>Podešavanja</div>
            </Link>
            <Link to={this.path("/obavjestenja")}>
              <div>Obavještenja</div>
            </Link>
            <Link to={this.path("/statistika")}>
              <div>Statistika</div>
            </Link>
            <Link to={this.path("/organizovanjeproizvoda")}>
              <div>Organizovanje proizvoda</div>
            </Link>
            <Link to={this.path("/radnja/" + this.state.usersData.name.toLowerCase() + "#prosli")}>
              <div>Prodati proizvodi</div>
            </Link>
            <Link to={this.path("/kupljeniproizvodi")}>
              <div>Kupljeni proizvodi</div>
            </Link>

            <Link to={this.path("/svekategorije")}>
              <div className="header_group_spacing">Kupovina</div>
            </Link>
            {this.state.usersData.id ? (
              <Link to={this.path("/novaprodaja")}>
                <div className="header_group_spacing">Nova prodaja</div>
              </Link>
            ) : (
              <Link to={this.path("/registracija")}>
                <div>Registracija</div>
              </Link>
            )}
            <Link to={this.path("/placanje")}>
              <div>Pogodnosti i cijena</div>
            </Link>
            <Link to={this.path("/uslovikoristenja")}>
              <div>Pravila i uslovi</div>
            </Link>
            <Link to={this.path("/kontakt")}>
              <div>Kontakt</div>
            </Link>

            <div className="header_group_spacing" onClick={this.doLogOut}>
              Odjava
            </div>
          </div>
        )}
      </div>
    );
  }
}

// Wrapper component with hooks
export const Header = (props) => {
  const { currentLanguage, changeLanguage, getPathWithLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <HeaderComponent 
      {...props} 
      currentLanguage={currentLanguage}
      changeLanguage={changeLanguage}
      getPathWithLanguage={getPathWithLanguage}
      t={t}
    />
  );
};
